export default __webpack_public_path__ + "static/media/nav_icon.ff25ec18.PNG";